import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from '@mui/material/Unstable_Grid2';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled } from '@mui/material/styles';
import SynthiumLogoLoader from "../static/POET_Logo_Pen.png";
 
const PulsingLogo = styled('img')({
  width: "100px",
  height: "100px",
  '@keyframes pulse': {
    '0%, 100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 0.7,
      transform: 'scale(1.05)',
    },
  },
  animation: 'pulse 1.5s ease-in-out infinite',
});
 
 
const RotatingLogo = styled('img')({
  width: "80px",
  height: "80px",
  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  animation: 'rotate 2s linear infinite',
});
 
const Loader = ({ loading, online }) => {
  if (!loading) return null;
 
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      {online ? (
        <Card
          sx={{
            maxWidth: 400,
            backgroundColor: "#1976d2",
            color: "white"
          }}
        >
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              <Grid xs={2}>
                <ErrorOutlineIcon sx={{ fontSize: 40 }} />
              </Grid>
              <Grid xs={10}>
                <Typography variant="h6" sx={{ mb: 1, fontSize: "16px" }}>
                  Lost Connection
                </Typography>
                <Typography variant="body2">
                  Your internet session was interrupted. We'll try to reconnect...
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2.5
              }}
            >
              <RotatingLogo
                src={SynthiumLogoLoader}
                alt="Loading"
              />
            </Box>
          </CardContent>
        </Card>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <PulsingLogo
            src={SynthiumLogoLoader}
            alt="Loading"
          />
        </Box>
      )}
    </Box>
  );
};
 
export default Loader;